import { Link as HydrogenLink } from '@shopify/hydrogen';
import { FC, ReactNode } from 'react';
import { Route } from '../constants/Route';

type Props = Route & {
  target?: string;
  className?: string;
  onClick?: React.MouseEventHandler<HTMLAnchorElement>;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
  children: ReactNode;
};

export const Link: FC<Props> = ({
  target,
  className,
  onClick,
  onMouseEnter,
  onMouseLeave,
  children,
  ...route
}) => (
  <HydrogenLink
    to={generatePath(route)}
    target={target}
    className={className}
    onClick={onClick}
    onMouseEnter={onMouseEnter}
    onMouseLeave={onMouseLeave}
    children={children}
  />
);

const generatePath = (route: Route) => {
  switch (route.route) {
    case 'activate':
      return `/account/activate/${route.id}/${route.activationToken}`;
    case 'editAddress':
      return `/account/address/${route.addressId}/edit`;
    case 'address':
      return `/account/address`;
    case 'newAddress':
      return `/account/address/new`;
    case 'favorites':
      return `/account/favorites`;
    case 'orders':
      return `/account/orders`;
    case 'order':
      return `/account/orders/${route.id}`;
    case 'recover':
      return `/account/recover`;
    case 'reset':
      return `/account/reset/${route.id}/${route.resetToken}`;
    case 'account':
      return `/account`;
    case 'accountEmail':
      return `/account/email`;
    case 'editEmail':
      return `/account/email/edit`;
    case 'categories':
      return `/categories`;
    case 'category':
      return `/categories/${route.handle}`;
    case 'features':
      return `/features`;
    case 'feature':
      return `/features/${route.handle}`;
    case 'guides':
      return `/guides`;
    case 'shipping':
      return `/guides/shipping`;
    case 'payment':
      return `/guides/payment`;
    case 'refunds':
      return `/guides/refunds`;
    case 'ordermade':
      return `/guides/custom`;
    case 'howto':
      return `/guides/paw`;
    case 'questions':
      return `/guides/faq`;
    case 'products':
      return `/products`;
    case 'product':
      return `/products/${route.handle}`;
    case 'about':
      return `/about`;
    case 'cart':
      return `/cart`;
    case 'contact':
      return `/contact`;
    case 'home':
      return `/`;
    case 'login':
      return `/login`;
    case 'logout':
      return `/logout`;
    case 'ranking':
      return `/ranking`;
    case 'recommends':
      return `/recommend`;
    case 'register':
      return `/register`;
    case 'news':
      return `/news`;
    case 'newsDetail':
      return `/news/${route.handle}`;
    case 'search':
      return `/search?q=${encodeURIComponent(route.query)}`;
    case 'withdraw':
      return `/account/withdraw`;
    case 'completeWithdraw':
      return `/account/withdraw/complete`;
    case 'url':
      return route.url;
    case 'legal':
      return '/legal';
    case 'privacy':
      return '/privacy';
    case 'terms':
      return '/terms';
    case 'gift':
      return '/guides/shipping#gift';
    case 'scene':
      return `/scenes/${route.handle}`;
    case 'newArrivals':
      return '/products/new';
    case 'scenes':
      return '/scenes';
  }
};
